/* ══════════════════ ALIA · PRIVE — single motion runtime ══════════════════
   ONE Lenis instance, ONE ScrollTrigger registry, spanning every section.
   Section-aware: each Shopify section boots into a per-id teardown registry so
   the theme editor can inject / reorder / remove sections without leaking
   timelines or duplicating animations.
   Loaded with `defer`, after GSAP + ScrollTrigger + SplitText + Lenis.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
"use strict";

document.documentElement.classList.add('js');

var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var COARSE = window.matchMedia && window.matchMedia('(pointer:coarse)').matches;
var hasGSAP = typeof window.gsap !== 'undefined';
var hasST = hasGSAP && typeof window.ScrollTrigger !== 'undefined';
var hasSplit = hasGSAP && typeof window.SplitText !== 'undefined';
var hasLenis = typeof window.Lenis !== 'undefined';
var DPR = Math.min(window.devicePixelRatio || 1, 2);
var $ = function(s,c){return (c||document).querySelector(s);};
var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
function clamp(v,a,b){return v<a?a:v>b?b:v;}
function lerp(a,b,t){return a+(b-a)*t;}
function pad2(n){return ('0'+Math.floor(n)).slice(-2);}

if(hasST){ gsap.registerPlugin(ScrollTrigger); }
if(hasSplit){ try{gsap.registerPlugin(SplitText);}catch(e){} }

/* ────────────────────────────────────────────────────────────────────────
   PER-SECTION TEARDOWN REGISTRY  (trap H)
   Every ScrollTrigger / tween / matchMedia / interval / listener created for
   a section is pushed onto REG[sectionId]. shopify:section:unload kills
   exactly that section's own and nothing else.
   ──────────────────────────────────────────────────────────────────────── */
var REG = {};
function track(id, fn){ (REG[id] || (REG[id] = [])).push(fn); }
function destroy(id){
  var list = REG[id];
  if(!list) return;
  for(var i=list.length-1;i>=0;i--){ try{ list[i](); }catch(e){} }
  delete REG[id];
}
/* helpers that register their own teardown */
function killLater(id, tween){
  if(!tween) return tween;
  track(id, function(){
    var arr = tween.length ? tween : [tween];
    for(var i=0;i<arr.length;i++){
      var t = arr[i];
      if(t && t.scrollTrigger) t.scrollTrigger.kill();
      if(t && t.kill) t.kill();
    }
  });
  return tween;
}
function stLater(id, st){ if(st) track(id, function(){ st.kill(true); }); return st; }
function mmLater(id, mm){ if(mm) track(id, function(){ mm.revert(); }); return mm; }
function ivLater(id, iv){ track(id, function(){ clearInterval(iv); }); return iv; }
function onLater(id, target, type, fn, opts){
  target.addEventListener(type, fn, opts);
  track(id, function(){ target.removeEventListener(type, fn, opts); });
}
function readJSON(root, attr, fallback){
  var el = root.querySelector('script[type="application/json"][' + attr + ']');
  if(!el) return fallback;
  try{ return JSON.parse(el.textContent); }catch(e){ return fallback; }
}

/* ────────────────────────────────────────────────────────────────────────
   APP STATE — cross-section boot handshake (preloader → hero)
   ──────────────────────────────────────────────────────────────────────── */
var APP = { booted:false };
function fireBoot(){
  if(APP.booted) return;
  APP.booted = true;
  try{ document.dispatchEvent(new CustomEvent('prive:boot')); }
  catch(e){ var ev=document.createEvent('Event'); ev.initEvent('prive:boot',true,true); document.dispatchEvent(ev); }
}

function refreshST(){ if(hasST) ScrollTrigger.refresh(); }

/* ══════════════════════════════════════════════════════════════════════
   GLOBAL, ONCE: Lenis + ScrollTrigger sync, anchors, easter egg, refreshes
   ══════════════════════════════════════════════════════════════════════ */
var lenis = null;
if(hasLenis && !RM){
  try{
    lenis = new Lenis({duration:1.15,smoothWheel:true,lerp:.1});
    if(hasST){
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function(t){ lenis.raf(t*1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      (function rafl(t){lenis.raf(t);requestAnimationFrame(rafl);})();
    }
  }catch(e){ lenis=null; }
}
/* The widget (assets/alia-widget.js) must stop smooth scrolling while its modal
   is open, or the page scrolls behind the dialog. It looks for ALIA_LENIS first
   and the app namespace second — publish both so either lookup resolves. */
window.ALIA_LENIS = lenis;
window.__ALIA_PRIVE__ = { lenis: lenis };

/* Anchor smooth scroll — delegated, so sections injected by the editor need no
   rebind.

   Handles BOTH "#cfg" and "/#cfg". The nav renders on every template now, and a
   bare "#cfg" is dead on a blog or article page — the target only exists on the
   index. So every in-page link is authored as "/#cfg", which navigates home and
   then jumps. This handler intercepts that form only when we are ALREADY on the
   home page, where it should scroll smoothly instead of reloading. */
document.addEventListener('click', function(e){
  var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
  if(!a) return;
  if(a.target === '_blank') return;
  var href = a.getAttribute('href') || '';
  var hash = '';
  if(href.charAt(0) === '#'){
    hash = href;
  } else if(href.charAt(0) === '/'){
    var i = href.indexOf('#');
    /* only "/#foo", and only while the home page is the one on screen */
    if(i > 0 && href.slice(0,i) === '/' && location.pathname === '/') hash = href.slice(i);
  }
  if(!hash || hash.length < 2) return;
  var el;
  try{ el = document.querySelector(hash); }catch(err){ return; }
  if(!el) return;
  e.preventDefault();
  if(lenis){ lenis.scrollTo(el,{offset:-6,duration:1.2}); }
  else { el.scrollIntoView({behavior:RM?'auto':'smooth'}); }
});

/* easter egg: type ALIA */
window.addEventListener('keydown', (function(){
  var buf='';
  return function(e){
    if(!e.key || e.key.length!==1) return;
    buf=(buf+e.key.toLowerCase()).slice(-4);
    if(buf==='alia'){
      var flare=document.createElement('div');
      flare.style.cssText='position:fixed;inset:0;z-index:9997;pointer-events:none;background:radial-gradient(50% 50% at 50% 60%,rgba(138,95,58,0.5),transparent 60%);opacity:0';
      document.body.appendChild(flare);
      if(hasGSAP){ gsap.to(flare,{opacity:1,duration:.5,ease:'power2.out',onComplete:function(){gsap.to(flare,{opacity:0,duration:1.4,ease:'power2.in',onComplete:function(){flare.remove();}});}}); }
      else { setTimeout(function(){flare.remove();},1500); }
    }
  };
})());

/* ────────────────────────────────────────────────────────────────────────
   IMAGE PREVIEW — one lightbox for the whole page.

   Delegated on document, so images inside a section the editor injects later
   are covered with no rebinding and no per-section teardown. The list of
   images is rebuilt on every open rather than cached, for the same reason.

   Only img[data-zoom] participates. prive-image.liquid stamps that attribute
   unless the caller passes zoom:false, which the hero/interlude/reserve
   backdrops and the three logos do.
   ──────────────────────────────────────────────────────────────────────── */
(function(){
  var lb=null, fig=null, img=null, cap=null, count=null, list=[], i=0, lastFocus=null;

  function build(){
    lb=document.createElement('div');
    lb.className='lb'; lb.hidden=true;
    lb.setAttribute('role','dialog');
    lb.setAttribute('aria-modal','true');
    lb.setAttribute('aria-label','Image preview');
    lb.innerHTML =
      '<span class="lb-count"></span>'+
      '<button type="button" class="lb-x" aria-label="Close">✕</button>'+
      '<button type="button" class="lb-btn lb-prev" aria-label="Previous image">‹</button>'+
      '<figure class="lb-fig"><img class="lb-img" alt=""><figcaption class="lb-cap"></figcaption></figure>'+
      '<button type="button" class="lb-btn lb-next" aria-label="Next image">›</button>';
    document.body.appendChild(lb);
    fig=lb.querySelector('.lb-fig'); img=lb.querySelector('.lb-img');
    cap=lb.querySelector('.lb-cap'); count=lb.querySelector('.lb-count');
    lb.querySelector('.lb-x').addEventListener('click', close);
    lb.querySelector('.lb-prev').addEventListener('click', function(e){ e.stopPropagation(); go(-1); });
    lb.querySelector('.lb-next').addEventListener('click', function(e){ e.stopPropagation(); go(1); });
    /* clicking the backdrop closes; clicking the picture itself does not */
    lb.addEventListener('click', function(e){ if(!fig.contains(e.target)) close(); });
  }

  function show(){
    var el=list[i];
    if(!el) return;
    img.src = el.getAttribute('data-full') || el.currentSrc || el.src;
    img.alt = el.getAttribute('alt') || '';
    cap.textContent = el.getAttribute('alt') || '';
    cap.hidden = !cap.textContent;
    count.textContent = (i+1)+' / '+list.length;
    lb.classList.toggle('lb-solo', list.length<2);
  }
  function go(d){ if(list.length<2) return; i=(i+d+list.length)%list.length; show(); }

  function open(el){
    if(!lb) build();
    /* rebuilt each time: sections come and go in the editor */
    list = $$('img[data-zoom]').filter(function(n){ return n.offsetParent !== null; });
    i = list.indexOf(el);
    if(i < 0){ list=[el]; i=0; }
    lastFocus = document.activeElement;
    show();
    lb.hidden=false;
    void lb.offsetHeight;
    lb.classList.add('on');
    document.body.classList.add('lb-open');
    if(lenis && lenis.stop) lenis.stop();
    lb.querySelector('.lb-x').focus();
  }
  function close(){
    if(!lb || lb.hidden) return;
    lb.classList.remove('on');
    document.body.classList.remove('lb-open');
    if(lenis && lenis.start) lenis.start();
    setTimeout(function(){ if(!lb.classList.contains('on')){ lb.hidden=true; img.removeAttribute('src'); } }, 300);
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function(e){
    var el = e.target.closest ? e.target.closest('img[data-zoom]') : null;
    if(!el) return;
    /* an image inside a link belongs to the link */
    if(el.closest('a,button')) return;
    e.preventDefault();
    open(el);
  });
  document.addEventListener('keydown', function(e){
    if(!lb || lb.hidden) return;
    if(e.key==='Escape'){ close(); }
    else if(e.key==='ArrowLeft'){ go(-1); }
    else if(e.key==='ArrowRight'){ go(1); }
  });
})();

/* refresh on fonts + load */
if(hasST){
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ ScrollTrigger.refresh(); }); }
  window.addEventListener('load',function(){ setTimeout(refreshST,260); });
  setTimeout(refreshST,700);
}

/* if no preloader is present at all, release the hero anyway */
setTimeout(fireBoot, 2600);

/* ══════════════════════════════════════════════════════════════════════
   SECTION MODULES
   Each receives (host, sectionId). `host` is the module's root element.
   ══════════════════════════════════════════════════════════════════════ */

/* ---------- PRELOADER (<=2.5s) ---------- */
function modPreloader(pre, id){
  /* trap E: the editor may re-inject this section long after boot. Never
     re-run the overlay — dismiss it on sight. */
  if(APP.booted){
    pre.classList.add('gone');
    if(pre.parentNode) pre.parentNode.removeChild(pre);
    return;
  }
  var bar = $('.pre-bar i',pre), pct = $('.pre-pct',pre);
  var letters = $$('.pre-logo span',pre), sub = $('.pre-sub',pre);
  var p = 0, done = false, killed = false;
  track(id, function(){ killed = true; });
  if(hasGSAP && !RM){
    killLater(id, gsap.to(letters,{opacity:1,y:0,duration:.66,stagger:.1,ease:'power3.out'}));
    killLater(id, gsap.to(sub,{opacity:1,duration:.6,delay:.5}));
  } else { letters.forEach(function(m){m.style.opacity=1;m.style.transform='none';}); if(sub)sub.style.opacity=1; }
  var iv = ivLater(id, setInterval(function(){
    p += Math.random()*18+11; if(p>=100){p=100;}
    if(bar)bar.style.width=p+'%';
    if(pct)pct.textContent=pad2(p);
    if(p>=100 && !done){done=true;clearInterval(iv);setTimeout(finish,260);}
  },110));
  function finish(){
    if(killed) return;
    pre.classList.add('gone');
    fireBoot();
    setTimeout(function(){ if(pre&&pre.parentNode){pre.parentNode.removeChild(pre);} refreshST(); },720);
  }
  var to = setTimeout(function(){ if(!done){done=true;clearInterval(iv);finish();} },2200);
  track(id, function(){ clearTimeout(to); });
}

/* ---------- CUSTOM CURSOR ---------- */
function modCursor(ring, id){
  if(COARSE) return;
  var dot = document.querySelector('.cur-dot');
  if(!ring||!dot) return;
  var mx=window.innerWidth/2,my=window.innerHeight/2,rx=mx,ry=my,raf=0,alive=true;
  onLater(id, window, 'mousemove', function(e){
    mx=e.clientX;my=e.clientY;dot.style.transform='translate('+mx+'px,'+my+'px)';
  }, {passive:true});
  function loop(){ if(!alive)return; rx=lerp(rx,mx,.18);ry=lerp(ry,my,.18);ring.style.transform='translate('+rx+'px,'+ry+'px)';raf=requestAnimationFrame(loop); }
  loop();
  track(id, function(){ alive=false; if(raf)cancelAnimationFrame(raf); document.body.classList.remove('cur-hot'); });
  var hot='a,button,.cfg-tab,.fm-card,.dish,.sv-item,.inq-btn,.faq-q,.magnet,.occ-item,.room-fact';
  onLater(id, document, 'mouseover', function(e){ if(e.target.closest&&e.target.closest(hot)){document.body.classList.add('cur-hot');}});
  onLater(id, document, 'mouseout',  function(e){ if(e.target.closest&&e.target.closest(hot)){document.body.classList.remove('cur-hot');}});
}

/* ---------- NAV + PROGRESS ---------- */
function modNav(nav, id){
  var prog = document.querySelector('#prog');

  /* --bar-h drives the mega panel's top offset and .tpl-pad on the blog
     templates. The bar changes height when it shrinks, so publish the real
     measured value rather than guessing a constant. Measured only when the
     shrunk state actually flips, not on every scroll frame — offsetHeight
     forces a layout read. */
  var wasShrunk = null;
  function syncBarH(){
    var h = nav.offsetHeight;
    if(h) document.documentElement.style.setProperty('--bar-h', h + 'px');
  }

  function onScroll(){
    var y=window.pageYOffset||document.documentElement.scrollTop;
    if(nav){
      var shrunk = y>60;
      if(shrunk)nav.classList.add('shrunk'); else nav.classList.remove('shrunk');
      if(shrunk !== wasShrunk){
        wasShrunk = shrunk;
        /* the padding transition is .5s; measure after it settles */
        setTimeout(syncBarH, 520);
        syncBarH();
      }
    }
    if(prog){ var h=document.documentElement.scrollHeight-window.innerHeight; prog.style.width=(h>0?(y/h*100):0)+'%'; }
  }
  onLater(id, window, 'scroll', onScroll, {passive:true});
  onLater(id, window, 'resize', syncBarH);
  syncBarH();
  onScroll();
  track(id, function(){ document.documentElement.style.removeProperty('--bar-h'); });
}

/* ---------- MEGA MENU ---------- */
function modMega(btn, id){
  var nav = btn.closest ? btn.closest('#nav') : null;
  /* the panel is a SIBLING of #nav now (backdrop-filter would trap it), so it
     is never found by searching inside the bar */
  var panel = document.getElementById('megaPanel');
  if(!panel) return;

  /* CLICK ONLY — no hover-to-open, anywhere.
     Hover was gated behind (hover:hover) and (pointer:fine), but plenty of
     touch devices and touch laptops report both as true. A tap then fired
     mouseenter, the full-screen sheet opened unnoticed, and the page appeared
     to stop scrolling. A menu that opens without being asked is worse than one
     extra tap, so the gate is gone rather than tightened. */
  var isOpen = false, hideT = 0;

  /* The full-screen sheet is a WIDTH-based design, so the scroll lock that goes
     with it is width-based too — not pointer-based, which is what it keyed off
     before and why it could latch on a touch laptop. */
  var mqSheet = window.matchMedia ? window.matchMedia('(max-width:900px)') : null;
  function isSheet(){ return mqSheet ? mqSheet.matches : window.innerWidth <= 900; }

  function setOpen(open){
    if(open === isOpen) return;
    isOpen = open;
    clearTimeout(hideT);
    if(open){
      panel.hidden = false;
      /* read layout once so the transition runs from the closed state rather
         than being collapsed into the same frame as display:block */
      void panel.offsetHeight;
      panel.classList.add('open');
    } else {
      panel.classList.remove('open');
      /* keep it out of the a11y tree once the fade has finished */
      hideT = setTimeout(function(){ if(!isOpen) panel.hidden = true; }, 360);
    }
    btn.setAttribute('aria-expanded', String(open));
    /* the full-screen sheet owns the viewport; the desktop dropdown does not */
    if(open && isSheet()) document.body.classList.add('mega-open');
    else document.body.classList.remove('mega-open');
  }

  onLater(id, btn, 'click', function(e){ e.stopPropagation(); setOpen(!isOpen); });

  /* rotating the phone mid-open must not strand the lock on */
  onLater(id, window, 'resize', function(){
    if(isOpen && !isSheet()) document.body.classList.remove('mega-open');
    else if(isOpen && isSheet()) document.body.classList.add('mega-open');
  });

  /* anything actionable inside the panel closes it on the way out, including
     the Corporate card — the widget's own document handler still opens the
     form, this just gets the panel out of the way first */
  onLater(id, panel, 'click', function(e){
    var t = e.target;
    if(t.closest && t.closest('a,button')) setOpen(false);
  });

  onLater(id, document, 'click', function(e){
    if(!isOpen) return;
    if(!panel.contains(e.target) && e.target !== btn && !btn.contains(e.target)) setOpen(false);
  });
  onLater(id, document, 'keydown', function(e){
    if(e.key === 'Escape' && isOpen){ setOpen(false); btn.focus(); }
  });

  track(id, function(){
    clearTimeout(hideT);
    document.body.classList.remove('mega-open');
  });
}

/* ---------- HERO ---------- */
function modHero(hero, id){
  var cfg = readJSON(hero, 'data-prive-hero', {});
  var title = (cfg.title || 'PRIVE');

  /* build hero title chars */
  (function(){
    var l1 = $('#heroL1', hero); if(!l1) return;
    var frag='';
    for(var i=0;i<title.length;i++){ frag+='<span class="ch">'+title[i]+'</span>'; }
    l1.innerHTML=frag;
  })();

  /* ember canvas — IntersectionObserver gated */
  (function(){
    var cv=$('#emberCanvas', hero); if(!cv||RM)return;
    var ctx=cv.getContext('2d'); if(!ctx)return;
    var W=0,H=0,parts=[],running=false,raf=0;
    function size(){
      var r=cv.getBoundingClientRect();
      cv.width=Math.max(1,Math.round(r.width*DPR));
      cv.height=Math.max(1,Math.round(r.height*DPR));
      W=cv.width;H=cv.height;
    }
    function mk(){
      return {x:Math.random()*W, y:H+Math.random()*H*0.3, r:(Math.random()*2.2+0.6)*DPR,
        vy:-(Math.random()*0.5+0.2)*DPR, vx:(Math.random()-0.5)*0.3*DPR,
        life:0, max:Math.random()*260+160, tw:Math.random()*6.28};
    }
    function init(){ parts=[]; var n=Math.round((W*H)/(46000*DPR)); n=clamp(n,26,84); for(var i=0;i<n;i++){var p=mk();p.y=Math.random()*H;p.life=Math.random()*p.max;parts.push(p);} }
    function frame(){
      if(!running)return;
      ctx.clearRect(0,0,W,H);
      for(var i=0;i<parts.length;i++){
        var p=parts[i];
        p.life++; p.tw+=0.05;
        p.y+=p.vy; p.x+=p.vx+Math.sin(p.tw)*0.25*DPR;
        if(p.life>p.max||p.y<-20){ parts[i]=mk(); continue; }
        var t=p.life/p.max;
        var a=Math.sin(t*Math.PI)*0.8*(0.6+0.4*Math.sin(p.tw));
        var g=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,p.r*3.2);
        g.addColorStop(0,'rgba(238,237,227,'+(a*0.5)+')');
        g.addColorStop(0.4,'rgba(138,95,58,'+(a*0.55)+')');
        g.addColorStop(1,'rgba(138,95,58,0)');
        ctx.fillStyle=g;
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r*3.2,0,6.2832); ctx.fill();
      }
      raf=requestAnimationFrame(frame);
    }
    size(); init();
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){ if(!running){running=true;frame();} }
        else { running=false; if(raf)cancelAnimationFrame(raf); }
      });
    },{threshold:0.02});
    io.observe(cv);
    var rt;
    function onResize(){ clearTimeout(rt); rt=setTimeout(function(){size();init();},200); }
    onLater(id, window, 'resize', onResize);
    track(id, function(){ running=false; if(raf)cancelAnimationFrame(raf); clearTimeout(rt); io.disconnect(); });
  })();

  /* blueprint draw */
  (function(){
    var bp=$('#heroBlueprint', hero); if(!bp)return;
    var shapes=$$('.bp-line,.bp-faint',bp);
    if(!(hasGSAP && !RM)){ return; }
    shapes.forEach(function(s){
      var len=0;
      try{ len = (s.getTotalLength ? s.getTotalLength() : 0); }catch(e){ len=0; }
      if(!len){ if(s.tagName==='rect'){var w=+s.getAttribute('width'),h=+s.getAttribute('height'); len=2*(w+h);} else if(s.tagName==='circle'){len=2*Math.PI*(+s.getAttribute('r'));} else {len=400;} }
      s.style.strokeDasharray=len; s.style.strokeDashoffset=len;
      killLater(id, gsap.to(s,{strokeDashoffset:0,duration:1.8,ease:'power2.out',delay:.5+Math.random()*0.5}));
    });
  })();

  /* doors countdown */
  (function(){
    var out=$('#doorsReadout b', hero); if(!out)return;
    var openHour = typeof cfg.openHour === 'number' ? cfg.openHour : 19;
    var closeHour = typeof cfg.closeHour === 'number' ? cfg.closeHour : 2;
    var doorsPrefix = (cfg.doorsPrefix || 'DOORS IN') + ' ';
    var openPrefix = cfg.openPrefix || 'ROOM OPEN · ';
    var openLabel = cfg.openLabel || 'SEATING NOW';
    function tick(){
      var now=new Date();
      var target=new Date(now); target.setHours(openHour,0,0,0);
      var open = now.getHours()>=openHour || now.getHours()<closeHour;
      if(open){
        out.parentNode.childNodes[0].nodeValue=openPrefix;
        out.textContent=openLabel;
      } else {
        if(now>target){ target.setDate(target.getDate()+1); }
        var d=Math.max(0,target-now), s=Math.floor(d/1000);
        var hh=Math.floor(s/3600), mm=Math.floor((s%3600)/60), ss=s%60;
        out.parentNode.childNodes[0].nodeValue=doorsPrefix;
        out.textContent=pad2(hh)+':'+pad2(mm)+':'+pad2(ss);
      }
    }
    tick(); ivLater(id, setInterval(tick,1000));
  })();

  /* hero intro — waits for the preloader handshake */
  var heroStarted=false;
  function startHero(){
    if(heroStarted)return; heroStarted=true;
    var chars=$$('#heroL1 .ch', hero);
    if(hasGSAP && !RM){
      gsap.set(chars,{yPercent:118,opacity:0});
      var tl=gsap.timeline();
      tl.to(chars,{yPercent:0,opacity:1,duration:1.1,ease:'power4.out',stagger:.06},0)
        .to($$('.hero-line2', hero),{opacity:1,y:0,duration:.9,ease:'power2.out'},.4)
        .to($$('.hero-sub', hero),{opacity:1,duration:.9,ease:'power2.out'},.5)
        .to($$('.hero-meta .m', hero),{opacity:1,y:0,duration:.7,ease:'power3.out',stagger:.09},.65)
        .to($$('.hero-foot', hero),{opacity:1,duration:.8},.85);
      killLater(id, tl);
    } else {
      chars.forEach(function(c){c.style.opacity=1;c.style.transform='none';});
      $$('.hero-line2,.hero-sub,.hero-meta .m,.hero-foot', hero).forEach(function(e){e.style.opacity=1;e.style.transform='none';});
    }
  }
  if(APP.booted){ startHero(); }
  else { onLater(id, document, 'prive:boot', startHero); }
}

/* ---------- INTRO / INTERLUDE word rises ---------- */
function wordRise(host, id){
  if(!host)return;
  var words=$$('.word i',host);
  if(!(hasGSAP && !RM)){ words.forEach(function(w){w.style.transform='none';}); return; }
  gsap.set(words,{yPercent:120});
  killLater(id, gsap.to(words,{yPercent:0,duration:1.05,ease:'power4.out',stagger:.06,
    scrollTrigger:{trigger:host,start:'top 82%',once:true}}));
}
function modIntro(host, id){ wordRise($('#introStatement', host), id); }
function modInterlude(host, id){ wordRise($('#interludeQ', host), id); }

/* ---------- OCCASIONS stagger ---------- */
function modOccasions(grid, id){
  var items=$$('.occ-item', grid);
  if(!items.length)return;
  if(hasST && !RM){
    killLater(id, gsap.to(items,{opacity:1,y:0,duration:.7,ease:'power3.out',stagger:.05,
      scrollTrigger:{trigger:grid,start:'top 85%',once:true}}));
  } else { items.forEach(function(i){i.style.opacity=1;i.style.transform='none';}); }
}

/* ══════════════ CONFIGURATOR ══════════════ */
function modConfigurator(cfgSection, id){
  var data = readJSON(cfgSection, 'data-prive-formats', {});
  var FORMATS = data.formats || {};
  var busyLabel = data.busyLabel || 'Re-Arranging Floor';
  var groups={ dinner:$('#fmtDinner',cfgSection), cocktail:$('#fmtCocktail',cfgSection), buyout:$('#fmtBuyout',cfgSection) };
  var tabs=$$('.cfg-tab',cfgSection), plan=$('#cfgPlan',cfgSection);
  var elName=$('#cfgName',cfgSection), elDesc=$('#cfgDesc',cfgSection), elIdx=$('#cfgIdx',cfgSection),
      elCap=$('#cfgCap',cfgSection), elLayout=$('#cfgLayout',cfgSection), elService=$('#cfgService',cfgSection), elRoom=$('#cfgRoom',cfgSection);
  var elProg=$('#cfgProg',cfgSection), elBar=$('#cfgProgBar',cfgSection), elStatus=$('#cfgStatusLabel',cfgSection);
  if(!tabs.length||!groups.dinner||!FORMATS.dinner)return;
  var current='dinner', busy=false, progObj={v:100};

  function paintText(key){
    var f=FORMATS[key]; if(!f)return;
    if(elName)elName.textContent=f.name;
    if(elDesc)elDesc.textContent=f.desc;
    if(elIdx)elIdx.textContent=f.idx;
    if(elCap)elCap.textContent=f.cap;
    if(elLayout)elLayout.textContent=f.layout;
    if(elService)elService.textContent=f.service;
    if(elRoom)elRoom.textContent=f.room;
  }
  function setProgUI(v){
    if(elProg)elProg.textContent=Math.round(v)+'%';
    if(elBar)elBar.style.width=v+'%';
  }

  function go(key){
    if(key===current || busy || !FORMATS[key]) { return; }
    current=key;
    tabs.forEach(function(t){
      var on=t.getAttribute('data-format')===key;
      t.classList.toggle('active',on);
      t.setAttribute('aria-selected',on?'true':'false');
    });
    paintText(key);
    if(plan)plan.classList.toggle('buyout-glow',key==='buyout');

    if(!(hasGSAP && !RM)){
      Object.keys(groups).forEach(function(k){ if(groups[k]) groups[k].classList.toggle('on',k===key); });
      setProgUI(100);
      if(elStatus)elStatus.textContent=FORMATS[key].status;
      return;
    }

    busy=true;
    if(elStatus)elStatus.textContent=busyLabel;
    /* fade out previous groups */
    Object.keys(groups).forEach(function(k){
      if(k!==key && groups[k]){ groups[k].classList.remove('on'); killLater(id, gsap.to(groups[k],{opacity:0,duration:.35,ease:'power2.in'})); }
    });
    /* progress readout */
    progObj.v=0; setProgUI(0);
    killLater(id, gsap.to(progObj,{v:100,duration:1.0,ease:'power2.inOut',onUpdate:function(){ setProgUI(progObj.v); },
      onComplete:function(){ if(elStatus)elStatus.textContent=FORMATS[key].status; busy=false; }}));
    /* fade in + stagger children */
    var g=groups[key];
    g.classList.add('on');
    gsap.set(g,{opacity:1});
    var kids=$$('.ce',g);
    killLater(id, gsap.fromTo(kids,{opacity:0,scale:.5},{opacity:1,scale:1,duration:.7,ease:'back.out(1.5)',
      stagger:{each:.03,from:'center'}, transformOrigin:'50% 50%'}));
  }

  tabs.forEach(function(t){
    onLater(id, t, 'click', function(){ go(t.getAttribute('data-format')); });
  });

  /* init: ensure dinner shown, others hidden */
  Object.keys(groups).forEach(function(k){ if(k!=='dinner' && groups[k]){ if(hasGSAP)gsap.set(groups[k],{opacity:0}); groups[k].classList.remove('on'); } });
  groups.dinner.classList.add('on');
  paintText('dinner'); setProgUI(100);
  if(elStatus)elStatus.textContent=FORMATS.dinner.status;
}

/* ══════════════ EVENING SCRIPT (pinned typewriter) ══════════════ */
function modEveningScript(esSection, id){
  var data = readJSON(esSection, 'data-prive-script', {});
  var SCRIPT = (data.cues && data.cues.length) ? data.cues : [];
  var cuePixels = typeof data.cuePixels === 'number' ? data.cuePixels : 180;
  var clockPrefix = data.clockPrefix || 'Montreal';
  var wrap=$('#esLines',esSection); if(!wrap||!SCRIPT.length)return;
  var cueOut=$('#esCue',esSection), totalOut=$('#esTotal',esSection);
  if(totalOut)totalOut.textContent=pad2(SCRIPT.length);

  /* build DOM */
  wrap.innerHTML='';
  var lineEls=[];
  SCRIPT.forEach(function(s){
    var row=document.createElement('div'); row.className='sl';
    var tm=document.createElement('span'); tm.className='sl-time'; tm.textContent=s.t;
    var cue=document.createElement('span'); cue.className='sl-cue';
    var txt=document.createElement('span'); txt.className='sl-txt';
    var car=document.createElement('span'); car.className='sl-caret'; car.textContent='▍';
    cue.appendChild(txt); cue.appendChild(car);
    row.appendChild(tm); row.appendChild(cue);
    wrap.appendChild(row);
    lineEls.push({row:row,txt:txt,full:s.c,lastN:-1});
  });
  track(id, function(){ wrap.innerHTML=''; });

  var activeCue=-1;
  function render(pos){
    var N=SCRIPT.length;
    var doneCount=0;
    for(var i=0;i<N;i++){
      var L=lineEls[i];
      var local=clamp(pos-i,0,1);
      var started=local>0;
      var full=L.full;
      var n = started ? Math.round(local*full.length) : 0;
      var complete = local>=1;
      if(started){ L.row.classList.add('started'); } else { L.row.classList.remove('started'); }
      L.row.classList.toggle('typing', started && !complete);
      L.row.classList.toggle('done', complete);
      if(n!==L.lastN){ L.txt.textContent=full.slice(0,n); L.lastN=n; }
      if(complete)doneCount++;
    }
    if(cueOut && doneCount!==activeCue){ activeCue=doneCount; cueOut.textContent=pad2(doneCount); }
  }
  render(0.0001);

  var pin=$('#esPin',esSection);
  var trigger=$('#es',esSection) || esSection;
  if(hasST && !RM){
    var mm=mmLater(id, gsap.matchMedia());
    mm.add('(min-width:861px)',function(){
      var st=ScrollTrigger.create({
        trigger:trigger, start:'top top', end:'+='+(SCRIPT.length*cuePixels+600), scrub:.5,
        pin:pin, anticipatePin:1,
        onUpdate:function(self){ render(self.progress*(SCRIPT.length+0.4)); }
      });
      return function(){ if(st)st.kill(true); };
    });
    mm.add('(max-width:860px)',function(){
      var st=ScrollTrigger.create({
        trigger:trigger, start:'top 78%', end:'bottom 60%', scrub:.5,
        onUpdate:function(self){ render(self.progress*(SCRIPT.length+0.4)); }
      });
      return function(){ if(st)st.kill(true); };
    });
  } else {
    render(SCRIPT.length+1);
  }

  /* doc clock */
  var clock=$('#esClock',esSection);
  function ck(){ if(!clock)return; var d=new Date(); clock.textContent=clockPrefix+' · '+pad2(d.getHours())+':'+pad2(d.getMinutes()); }
  ck(); ivLater(id, setInterval(ck,1000));
}

/* ---------- MAGNETIC BUTTON ---------- */
function modReserve(reserveSection, id){
  if(COARSE||RM)return;
  var m=$('#magReserve',reserveSection); if(!m||!hasGSAP)return;
  onLater(id, m, 'mousemove', function(e){
    var r=m.getBoundingClientRect();
    var x=e.clientX-r.left-r.width/2, y=e.clientY-r.top-r.height/2;
    gsap.to(m,{x:x*0.3,y:y*0.4,duration:.5,ease:'power3.out'});
  });
  onLater(id, m, 'mouseleave', function(){ gsap.to(m,{x:0,y:0,duration:.6,ease:'elastic.out(1,0.4)'}); });
  track(id, function(){ gsap.killTweensOf(m); });
}

/* ---------- FAQ ---------- */
function modFaq(faqSection, id){
  var items = $$('.faq-item', faqSection);
  items.forEach(function(it){
    var q=$('.faq-q',it), a=$('.faq-a',it);
    if(!q||!a)return;
    onLater(id, q, 'click', function(){
      var open=it.classList.contains('open');
      items.forEach(function(o){ o.classList.remove('open'); var oa=$('.faq-a',o),oq=$('.faq-q',o); if(oa)oa.style.maxHeight=null; if(oq)oq.setAttribute('aria-expanded','false'); });
      if(!open){ it.classList.add('open'); a.style.maxHeight=a.scrollHeight+'px'; q.setAttribute('aria-expanded','true'); }
    });
  });
}

/* ---------- FOOTER: year + marquee ---------- */
function modFooter(foot, id){
  var y=$('#yr',foot); if(y)y.textContent=new Date().getFullYear();
  var data = readJSON(foot, 'data-prive-footer', {});
  var dur = typeof data.marqueeDuration === 'number' ? data.marqueeDuration : 24;
  var track_=$('#footTrack',foot); if(!track_||!hasGSAP||RM)return;
  var half=track_.scrollWidth/2;
  if(!half)return;
  killLater(id, gsap.to(track_,{x:-half,duration:dur,ease:'none',repeat:-1,modifiers:{x:function(x){return (parseFloat(x)%half)+'px';}}}));
}

/* ---------- CTA DOCK reveal ---------- */
function modDock(dock, id){
  function reveal(){ dock.classList.add('revealed'); }
  if(APP.booted){ reveal(); return; }
  var SEL='#pre,#preloader,[id*="preload" i],[class*="preloader" i]';
  var pre=document.querySelector(SEL);
  if(pre){
    var start=new Date().getTime();
    var iv=ivLater(id, setInterval(function(){
      var el=document.querySelector(SEL), gone=!el;
      if(el){ var cs=getComputedStyle(el); gone=(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity)<0.1); }
      if(gone || (new Date().getTime()-start)>6000){ reveal(); clearInterval(iv); }
    },200));
  } else {
    onLater(id, document, 'prive:boot', reveal);
    var to=setTimeout(reveal,700);
    track(id, function(){ clearTimeout(to); });
  }
}

/* ---------- generic per-section reveals + h2 cascade ---------- */
function genericReveals(root, id){
  var els = $$('[data-reveal]', root);
  if(hasST && !RM){
    els.forEach(function(el){
      killLater(id, gsap.to(el,{opacity:1,y:0,duration:.95,ease:'power3.out',
        scrollTrigger:{trigger:el,start:'top 88%',once:true}}));
    });
  } else {
    els.forEach(function(el){el.style.opacity=1;el.style.transform='none';});
  }
}
function genericH2(root, id){
  if(!(hasSplit && hasST && !RM)) return;
  $$('.h2', root).forEach(function(h){
    try{
      var sp=new SplitText(h,{type:'chars'});
      track(id, function(){ try{ sp.revert(); }catch(e){} });
      gsap.set(sp.chars,{yPercent:110,opacity:0});
      killLater(id, gsap.to(sp.chars,{yPercent:0,opacity:1,duration:.8,ease:'power4.out',stagger:.022,
        scrollTrigger:{trigger:h,start:'top 90%',once:true}}));
    }catch(e){}
  });
}

/* ══════════════════════════════════════════════════════════════════════
   BOOT / REBOOT
   ══════════════════════════════════════════════════════════════════════ */
var MODULES = [
  { sel:'#pre',        init:modPreloader },
  { sel:'.cur',        init:modCursor },
  { sel:'#nav',        init:modNav },
  { sel:'#megaBtn',    init:modMega },
  { sel:'#hero',       init:modHero },
  { sel:'#intro',      init:modIntro },
  { sel:'#cfg',        init:modConfigurator },
  { sel:'#occGrid',    init:modOccasions },
  { sel:'#es',         init:modEveningScript },
  { sel:'#interlude',  init:modInterlude },
  { sel:'#reserve',    init:modReserve },
  { sel:'#faq',        init:modFaq },
  { sel:'#foot',       init:modFooter },
  { sel:'.alia-cta-dock', init:modDock }
];

var anon = 0;
function bootSection(root){
  if(!root) return;
  var id = root.id || ('prive-anon-' + (++anon));
  if(!root.id) root.setAttribute('data-prive-id', id);
  destroy(id);
  MODULES.forEach(function(m){
    var host = root.querySelector(m.sel);
    if(!host && root.matches && root.matches(m.sel)) host = root;
    if(host){ try{ m.init(host, id); }catch(e){} }
  });
  genericReveals(root, id);
  genericH2(root, id);
}

function bootAll(){
  var roots = $$('.shopify-section');
  if(!roots.length) roots = [document.body];
  roots.forEach(bootSection);
  refreshST();
}

/* the theme editor injects, reorders and removes sections at runtime */
document.addEventListener('shopify:section:load', function(e){
  bootSection(e.target);
  refreshST();
});
document.addEventListener('shopify:section:unload', function(e){
  destroy(e.target.id);
  refreshST();
});
document.addEventListener('shopify:section:reorder', refreshST);
document.addEventListener('shopify:section:select', refreshST);
document.addEventListener('shopify:section:deselect', refreshST);
document.addEventListener('shopify:block:select', refreshST);
document.addEventListener('shopify:block:deselect', refreshST);

bootAll();

})();
